import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '@/i18n/en.json';
import ne from '@/i18n/ne.json';

export default i18n.use(initReactI18next).init({
  resources: {
    en,
    ne,
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
